export default __webpack_public_path__ + "static/media/pelvisCTScan.11dea085.svg";